// Copyright (c) Ensho Health, 2021 to present

import { gql } from 'graphql-request';
import { workflowClient } from './client-gql.js';
import httpClient from './client-http.js';

export async function fetchResults(
  filters = null,
  offset,
  limit,
  patientId = null
) {
  try {
    const query = gql`
      query labResultsAll(
        $offset: Int!
        $limit: Int!
        $patientId: Int
        $orderingPhyId: Int
        $labs: [String]
        $abnormal: Boolean
        $notComputed: Boolean
        $dateStart: Int
        $dateEnd: Int
      ) {
        labResults {
          allResults(
            offset: $offset
            limit: $limit
            patientId: $patientId
            orderingPhyId: $orderingPhyId
            labs: $labs
            abnormal: $abnormal
            notComputed: $notComputed
            dateStart: $dateStart
            dateEnd: $dateEnd
          ) {
            labResultId
            patientId
            patientYob
            labTest
            labTestVersion
            resultDate
            isAbnormal
            notComputed
            riskClass
            seenOn
            orderingPhyId
            orderingPhyName
          }
        }
      }
    `;
    const variables = {
      offset,
      limit,
      abnormal: null,
      notComputed: null
    };
    if (patientId) {
      variables.patientId = patientId;
    }
    if (filters) {
      variables.orderingPhyId = filters.orderingPhyId;
      if (filters.labs) {
        variables.labs = filters.labs;
      }
      if (filters.labs) {
        variables.labs = filters.labs;
      }
      if (filters.normal) {
        variables.abnormal = false;
      } else if (filters.abnormal) {
        variables.abnormal = true;
      }
      variables.notComputed = filters.notComputable;
      if (filters.dateStart && filters.dateEnd) {
        variables.dateStart = filters.dateStart;
        variables.dateEnd = filters.dateEnd;
      }
    }
    const response = await workflowClient.request(query, variables);
    return response?.labResults?.allResults;
  } catch (error) {
    throw error;
  }
}

export async function fetchDetails(labResultId) {
  try {
    const query = gql`
      query labResultDetail($resultId: Int!) {
        labResults {
          resultDetail(resultId: $resultId) {
            mnd5ResultId
            ca4fResultId
            clinicId
            constellation
            trialId
            orderingPhysician
            orderId
            outcome
            patientId
            notComputable
            riskScore
            riskClass
            isAbnormal
            resultTime
            estimatorVersion
            controllerVersion
            supportingEvidence
            otherEvidence
          }
        }
      }
    `;
    const variables = {
      resultId: labResultId
    };
    const response = await workflowClient.request(query, variables);
    let jsonEvidence = null;
    if (response?.labResults?.resultDetail?.otherEvidence) {
      try {
        jsonEvidence = JSON.parse(
          response?.labResults?.resultDetail?.otherEvidence
        );
      } catch (error) {
        console.error(error.message);
      }
    }
    return {
      ...response?.labResults?.resultDetail,
      otherEvidence: jsonEvidence
    };
  } catch (error) {
    throw error;
  }
}

export async function fetchOrderingPhy(labResultId) {
  try {
    const query = gql`
      query orderingPhyList {
        labResults {
          orderingPhyList {
            physicianId
            clinicId
            name
            specialty
            subspecialty
            firstName
            lastName
            code
          }
        }
      }
    `;
    const response = await workflowClient.request(query);
    return response?.labResults?.orderingPhyList;
  } catch (error) {
    throw error;
  }
}

export async function submitSupport(info) {
  try {
    if (!info.reasons) {
      info.reasons = [];
    }
    if (info.trialId && typeof info.trialId !== 'string') {
      info.trialId = parseInt(info.trialId);
    }
    if (info.patientId && typeof info.patientId !== 'string') {
      info.patientId = parseInt(info.patientId);
    }
    const query = gql`
      mutation supportRequest(
        $trialId: Int!
        $patientId: Int!
        $lab: String
        $reasons: [String]
        $explanation: String!
      ) {
        supportRequest(
          trialId: $trialId
          patientId: $patientId
          lab: $lab
          reasons: $reasons
          explanation: $explanation
        ) {
          ok
          error
        }
      }
    `;
    const variables = { ...info };
    const response = await workflowClient.request(query, variables);
    return response?.supportRequest;
  } catch (error) {
    throw error;
  }
}

export async function dlReport(
  trialId,
  labResultId,
  hcn = null,
  patientName = null,
  dob = null
) {
  try {
    const uri = `reports/lab/v2/trials/${trialId}/result/${labResultId}`;

    const payload = {};
    if (hcn) {
      payload.hcn = hcn;
    }
    if (dob) {
      payload.dob = dob;
    }
    if (patientName) {
      payload.patientName = patientName.replace(/(^\w|\s\w)/gi, (match) =>
        match.toUpperCase()
      );
    }

    const response = await httpClient.post(uri, payload, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
}
